import { useEffect, useState } from "react";
import axios from "axios";

// Public price list from the admin editor (single source of truth for every page that shows prices).
export const usePrices = () => {
  const [data, setData] = useState(null);
  const [err, setErr] = useState(false);
  useEffect(() => {
    axios.get(`${process.env.REACT_APP_BACKEND_URL}/api/public/prices`).then((r) => setData(r.data)).catch(() => setErr(true));
  }, []);
  return { data, err };
};

export const allItems = (data) =>
  (Array.isArray(data?.categories) ? data.categories : []).flatMap((c) => (Array.isArray(c.items) ? c.items : []));

export const quoteUrl = (service, label) => `/?tjeneste=${service}&pris=${encodeURIComponent(label)}#kontakt`;

export const fmtDate = (iso) => {
  if (!iso) return "";
  const d = new Date(iso);
  return Number.isNaN(d.getTime()) ? "" : d.toLocaleDateString("nb-NO", { day: "2-digit", month: "2-digit", year: "numeric", timeZone: "Europe/Oslo" });
};
